import { GiTShirt, GiRolledCloth, GiClothes, GiTrousers } from "react-icons/gi";

const catalogue = {
  men: [
    { id: 1, name: "Men's Shirts", tag: "Tops", aspect: "aspect-[3/4]", Icon: GiTShirt },
    { id: 2, name: "Men's Trousers", tag: "Bottoms", aspect: "aspect-square", Icon: GiTrousers },
  ],
  women: [
    { id: 1, name: "Women's Kurtis", tag: "Ethnic", aspect: "aspect-[3/4]", Icon: GiClothes },
    { id: 2, name: "Women's Tunics", tag: "Ethnic", aspect: "aspect-square", Icon: GiRolledCloth },
    { id: 3, name: "Women's Short Kurti Tops", tag: "Tops", aspect: "aspect-[16/10]", Icon: GiClothes },
    { id: 4, name: "Women's Bottoms", tag: "Bottoms", aspect: "aspect-[3/4]", Icon: GiTrousers },
  ],
};

export default catalogue;
